import React, { useEffect, useState } from "react";
import styles from "./checkScooterStatus.module.scss";
import { useHistory } from "react-router";
import { makeAPICall } from "../../../services/apiService";

const CheckScooterStatus = () => {
  const history = useHistory();
  const [tableData, setTableData] = useState([]);
  const [totalTransit, setTotalTransit] = useState(0)
  const [totalAvailable, setTotalAvailable] = useState(0)
  const [SDC, setSDC] = useState(null);
  const [model, setModel] = useState(null);
  const [lastUpdated, setLastUpdated] = useState(null)
  const [experienceCenterList, setExperienceCenterList] = useState([])
  const [selectedExperienceCenter, setSelectedExperienceCenter] = useState(null)

  useEffect(() => {
     if (history?.location?.state?.scooterList) {
      setTableData(history?.location?.state?.scooterList)
     }
     if (history?.location?.state?.SDC) {
      setSDC(history?.location?.state?.SDC)
     }

     if (history?.location?.state?.model) {
      setModel(history?.location?.state?.model)
     }

     if (history?.location?.state?.lastUpdated) {
      setLastUpdated(new Date(history?.location?.state?.lastUpdated))
     }

     if (history?.location?.state?.experienceCenterList) {
      setExperienceCenterList(history?.location?.state?.experienceCenterList)
     }

     if (history?.location?.state?.selectedExperienceCenter) {
      setSelectedExperienceCenter(history?.location?.state?.selectedExperienceCenter)
     }
  }, [])

  useEffect(() => {
    if (tableData?.length) {
      let transitCount = 0, availableCount = 0
      tableData.forEach((item) => {
        transitCount += item?.transit_count
        availableCount += item?.available_count
      })
      setTotalTransit(transitCount)
      setTotalAvailable(availableCount)
    }
  }, [tableData])

  const handleCheck = () => {
    if (!model || !SDC) {
      return 
    }
    let url = `/api/checkEligibility/getAvailableScooters?sdc=${experienceCenterList?.length && (selectedExperienceCenter?.sdcCodeForXc || selectedExperienceCenter?.mappedSdc) ? (selectedExperienceCenter?.sdcCodeForXc || selectedExperienceCenter?.mappedSdc) : SDC?.sdc_code}&variant=${model?.product_name}&variant_product_id=${model?.entity_id}`
    let config = {
      method: "get",
      url: url,
    };


    makeAPICall(config)
      .then((resp) => {
        if (resp && resp?.data?.status === "SUCCESSFUL") {
          if (resp?.data?.data) {
            setTableData(resp?.data?.data?.availability_response)
            setLastUpdated(new Date(resp?.data?.data?.last_updated))
          }
        }
   
      })
      .catch((err) => {
        console.log(err)
      });
  }


  return (
    <div className={styles.wrapper}>
      <img
        className={styles.backIcon}
        src="https://assets.olaelectric.com/olaelectric-videos/configs-static/assets/extendedWarranty/BackArrowWithWhiteBackground.svg"
        alt="back"
        onClick={() => {
          history.goBack();
        }}
      />
      <div className={styles.container}>
        <h3 className={styles.title}>{model?.product_name}</h3>
        <div className={styles.descWrapper}>
          <p className={styles.desc}>{SDC?.sdc_name}</p> 
          <p className={styles.refreshCTA} onClick={handleCheck}>Refresh page</p>
        </div>
        <div className={styles.tableWrapper}>
          <table>
            <tr>
              <th>Color</th>
              <th>In transit</th>
              <th>Available</th>
            </tr>

            {
              tableData?.map((item) => (
                <tr>
                  <td>
                    <img src={item?.image_url} className={styles.colorIcon} />
                    <p className={styles.colorName}>
                      {item?.color}
                    </p>

                  </td>
                  <td>{item?.transit_count}</td>
                  <td style={{background: !item?.available_count ? "#F9EAEA" : "#F2F9E8"}}>{item?.available_count}</td>
                </tr>
              ))
            }

            {
              tableData?.length && (
                <tr style={{fontWeight: "bold"}}>
                  <td>
                   Total
                  </td>
                  <td>{totalTransit}</td>
                  <td>{totalAvailable}</td>
                </tr>
              )
            }

          </table>
        </div>
        <div className={styles.btmDesc}>
          Last updated : {lastUpdated?.toDateString()}
        </div>
      </div>
    </div>
  );
};

export default CheckScooterStatus;
